// eslint-disable-next-line no-restricted-imports
import { defaultTheme } from '@adobe/react-spectrum'

export const defaultSpectrumTheme = defaultTheme
